<style>
    .flip {
        /* width: 150px;
        height: 150px;    */
        text-align: center;
        perspective: 600px;  
    }
    .flip-content {
        /* width: 100%;
        height: 100%; */
        transition: transform 0.4s;
        transform-style: preserve-3d;
    }

    .actionFlip {
        transform: rotateY(180deg);
        transition: transform 0.3s;
    }
    
    .actionFlipContent {
        transform: rotateY(180deg);
        transition: transform 0.3s;
    }

    .flip-front, .flip-back {
        position: absolute;
        /* height: 100%;
        width: 100%; */
        line-height: 150px;
        backface-visibility: hidden;  
        color: #fff;  
        background-color: lightseagreen;
        border: 6px solid lightcoral;
        box-shadow: 6px 6px lightseagreen;
    }
    .flip-back {
        transform: rotateY(180deg);
        border: 6px solid lightseagreen;
        box-shadow: 6px 6px lightcoral;
    }

    .cant-click-this {
        pointer-events: none;
    }
</style>
<template>
    <div v-if="loading" class="loading">Loading...</div>
    <div :class="blur ? 'blur-lg' : '' " class="fixed h-screen w-screen bg-[url('../assets/background/sea.jpg')] bg-cover bg-center bg-no-repeat">
        <div class="flex h-full">

            <div class="w-4/6 h-full">
                <div class="flex flex-col p-2 gap-2">
                    <router-link :to="`/checkpoint`">
                        <div class="bg-white rounded-lg shadow-lg shadow-slate-500 w-fit p-2">
                            <img class="w-10" src="../assets/icon/icon-home.png" alt="home">
                        </div>
                    </router-link>
                    <div class="flex items-center justify-center xl:p-4 lg:p-1 md:p-1 sm:p-1 gap-x-6 border rounded-lg shadow-lg xl:mb-4 lg:mb-4 md:mb-2 sm:mb-1">
                        <p class="xl:text-6xl lg:text-6xl md:text-3xl sm:text-3xl text-white">จับคู่กัน</p>                                        
                        <Sound :checkpoint='6' :autoplay='false'/>
                    </div>   

                    <div class="flex justify-center items-center">
                        <div class="relative h-full grid gap-4 border-4 w-fit" :class="gap">
                            <div v-for="item in paths" :key="item" class="cursor-pointer">
                                <div class="flip hover:ring-8 xl:w-[150px] xl:h-[150px] lg:w-[150px] lg:h-[150px] md:w-[60px] md:h-[60px] sm:w-[60px] sm:h-[60px]" style="text-align: center; perspective: 600px;" :id="`card`+item.name" @click="flipCard(item.name, item.value)">
                                    <div class="flex justify-center items-center flip-content w-[100%] h-[100%]" style="transition: transform 0.4s;transform-style: preserve-3d;" :id="`content`+item.name">
                                        <div class="flip-front w-[100%] h-[100%]" style="position: absolute;line-height: 150px;backface-visibility: hidden;  color: #fff;  background-color: lightseagreen;border: 6px solid lightcoral;box-shadow: 6px 6px lightseagreen;"></div>
                                        <div class="flip-back w-[100%] h-[100%]" style="position: absolute;line-height: 150px;backface-visibility: hidden;  color: #fff;  background-color: lightseagreen;border: 6px solid lightcoral;box-shadow: 6px 6px lightseagreen;transform: rotateY(180deg);border: 6px solid lightseagreen;box-shadow: 6px 6px lightcoral;">
                                        <img :src="item.path" :alt="item.name">
                                        </div>
                                    </div>
                                </div>
                            </div>                        
                        </div>
                    </div> 

                </div>
            </div>

            <div class="flex justify-center w-2/6 h-full">
                <div class="flex flex-col justify-around">
                    <div>
                        <div class="text-4xl p-2 rounded-md border-4 text-center">
                            <p class="xl:text-6xl lg:text-6xl md:text-4xl sm:text-4xl font-bold xl:p-4 lg:p-0 md:p-0 sm:p-0 text-white">จำนวนครั้ง</p>
                        </div>
                        <div class="flex justify-center p-4">
                            <div class="xl:h-[120px] xl:w-[120px] lg:h-[120px] lg:w-[120px] md:h-[100px] md:w-[100px] sm:h-[90px] sm:w-[90px] rounded-full flex items-center justify-center ring-8 border-4">
                                <p class="xl:text-6xl lg:text-6xl md:text-4xl sm:text-4xl font-bold p-2 text-white">{{ countGame }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="xl:w-64 lg:w-64 md:w-40 sm:w-24">
                        <img src="../assets/avatar/avatar.png" alt="avatar">
                    </div>     
                </div>           
            </div>

        </div>
        <Answer :checkCorrect="checkCorrect" :resetGame="resetGame" :star="star" :nextCheckPoint="nextCheckPoint" />         
    </div>
    <HowTo :setShowContent="setShowContent" :checkpoint='6'/>
</template>

<script>
import HowTo from "../components/HowTo.vue";
import Answer from "../components/Answer.vue";
import Sound from "../components/Sound.vue";
import soundAnswer from "../js/sound-answer";
import actionUpdateCheckpoint from '../js/firebase-action';
import logPlay from '../js/logs-play';

const path = '../assets/checkpoint/6';

const checkpointEasy = ['measure', 'school', 'home'];
const checkpointMedium = ['spoon', 'shoes', 'chair', 'fan', 'broom'];
const checkpointHard = ['cat', 'tiger', 'dog', 'bird', 'sneck', 'elephant'];

// Shuffle function from http://stackoverflow.com/a/2450976
function shuffle(array) {
    var currentIndex = array.length, temporaryValue, randomIndex;

    while (currentIndex !== 0) {
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;
        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
    }

    return array;
}

const getCountMatchCard = (level) => {
    if(level === 'easy') {
        return checkpointEasy.length;
    } else if(level === 'medium') {
        return checkpointMedium.length;
    } else {
        return checkpointHard.length;
    }
}

const getImages = (level) => {
    let pathGetImageByLevel = [];

    if(level === 'easy') {
        pathGetImageByLevel = checkpointEasy.concat(checkpointEasy);
    } else if(level === 'medium') {
        pathGetImageByLevel = checkpointMedium.concat(checkpointMedium);
    } else {
        pathGetImageByLevel = checkpointHard.concat(checkpointHard);
    }

    pathGetImageByLevel = pathGetImageByLevel.map((item, index) => {
        return {
            name: item+index,
            value: item,
            path: `${path}/${item}.png`
        }
    });

    const shuffleImage = shuffle(pathGetImageByLevel);

    return shuffleImage;
}

const checkCardCorrect = (cards) => {
    const { cardOne, cardTwo } = cards;

    if(cardOne === cardTwo){        
        return true;
    }else{
        return false;
    }    
}

const checkGap = (level) => {
    if(level === 'easy') {
        return 'grid-cols-3';
    }else if(level === 'medium') {
        return 'grid-cols-5';
    }else{
        return 'grid-cols-4';
    }
}

export default {
    name: "CheckPointFlip",
    props: {
        msg: String,
    },
    components: {
        HowTo,
        Answer,
        Sound
    },
    data(){
        return {
            blur: true,               
            level: this.$store.state.level,
            gap: checkGap(this.$store.state.level),
            cardOne: '',
            idCardOne: '',
            cardTwo: '',
            idCardTwo: '',
            star: 0,
            checkCorrect: '',
            countGame: 0,
            countMatchCard: 0,
            wonMatchCard: getCountMatchCard(this.$store.state.level),
            paths: getImages(this.$store.state.level),            
            levels: {
                easy: [],
                medium: [],
                hard: []
            },            
        };        
    },
    created () {
        !this.$store.state.user_id ? window.location.replace("/#/logout/") : '';          
    },
    methods: {
        setShowContent() {
            this.blur = false;           
        },
        setShowModalCorrect() {
            // this.blur = true;
            this.checkCorrect = 'correct';
        },
        setShowModalInCorrect() {
            // this.blur = true;
            this.checkCorrect = 'incorrect';
        },        
        resetGame(){
            this.blur = false;
            this.checkCorrect = '';            
        },
        nextCheckPoint(){            
            const checkpoints = this.$store.state.checkpoints;
            const level = this.$store.state.level;
            var parseCheckpoint = JSON.parse(JSON.stringify(checkpoints));
            const starByCheckpoint = parseCheckpoint[level];
            const my_checkpoint = 6;
            const checkpoint_index = [1, 2, 3, 4, 5, 6];

            const next = checkpoint_index.filter((i) => {
                const star = starByCheckpoint[`checkpoint_${i}`];
                return i > my_checkpoint && star < 3 ? i : '';                
            });

            window.location.replace(`/#/checkpoint/${next.length > 0 ? next[0]: ''}`);
        },
        clearGame() {
            this.resetCards();
            this.countGame = 0;
            this.countMatchCard = 0;            
        },  
        debug() {
            console.log({
                    idCardOne: this.idCardOne,
                    cardOne: this.cardOne,
                    idCardTwo: this.idCardTwo,
                    cardTwo: this.cardTwo,    
            });            
        },
        resetCards(){
            this.idCardOne = '';
            this.cardOne = '';
            this.idCardTwo = '';
            this.cardTwo = '';
        },
        checkWonGame() {            
            if(this.countMatchCard === this.wonMatchCard) {
                console.log('count game'+ this.countGame);
                if(this.countGame < 20){
                    this.star = 3;
                }else if(this.countGame >= 20 && this.countGame < 30){
                    this.star = 2;
                }else {
                    this.star = 1;
                }

                this.updateCheckpointStarInFirebase();
                this.setShowModalCorrect();
                soundAnswer('correct');                
                this.paths.map((item) => {
                    document.getElementById(`content`+item.name).classList.remove("actionFlipContent");
                    document.getElementById(`card`+item.name).classList.remove("cant-click-this");
                });
                this.clearGame();
            }
        },
        flipCard(id, value) {            

            document.getElementById(`content`+id).classList.add("actionFlipContent");

            if(this.cardOne === ''){
                this.idCardOne = id;
                this.cardOne = value;
            }else{
                this.idCardTwo = id;
                this.cardTwo = value;

                const cards = {
                    idCardOne: this.idCardOne,
                    cardOne: this.cardOne,
                    idCardTwo: this.idCardTwo,
                    cardTwo: this.cardTwo,    
                }                

                const cardOneContent = document.getElementById(`content`+this.idCardOne);
                const cardTwoContent = document.getElementById(`content`+this.idCardTwo);

                const cardOne = document.getElementById(`card`+this.idCardOne);
                const cardTwo = document.getElementById(`card`+this.idCardTwo);

                const checkCardResult = checkCardCorrect(cards);
                if(!checkCardResult){
                    this.debug();
                    setTimeout(()=>{                        
                        cardOneContent.classList.remove("actionFlipContent");   
                        cardTwoContent.classList.remove("actionFlipContent");
                        this.resetCards();
                    }, 500);                                          
                }else{
                    this.debug();
                    cardOne.classList.add("cant-click-this");   
                    cardTwo.classList.add("cant-click-this");
                    this.resetCards();
                    this.countMatchCard ++;

                    setTimeout(()=>{                        
                        this.checkWonGame();
                    }, 200);                    
                }

                this.countGame++;                
            }                  
        },
        async updateCheckpointStarInFirebase() {
            const checkpoints = this.$store.state.checkpoints;
            const level = this.$store.state.level;
            const document_id = this.$store.state.user_id;
            const checkpointUpdate = {
                checkpoint_6: this.star
            }

            const user = this.$store.state.user;
            await logPlay(user, 6, this.star);

            var parseCheckpoint = JSON.parse(JSON.stringify(checkpoints));
            const starByCheckpoint = parseCheckpoint[level]['checkpoint_6'];         

            if(this.star > starByCheckpoint){
                parseCheckpoint[level]['checkpoint_6'] = this.star;
                await actionUpdateCheckpoint(document_id, level, checkpoints, checkpointUpdate);
                this.$store.dispatch('setCheckPoint', parseCheckpoint);
            }
        }
    }  
};
</script>